import initAssignVariable from './init-assign-variable';
import interpolateStringToTemplate from './interpolate-string-to-template';
import parseTemplate from './parse-template';
import parseHslaColorString from './parse-hsla-color-string';
import parseColors from './parse-colors';

export default {
  initAssignVariable,
  interpolateStringToTemplate,
  parseTemplate,
  parseHslaColorString,
  parseColors,
};
